import MenuComponents from "./MenuComponent";
import styles from "./Menu.module.css";

import { PiFilePdfDuotone } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import {
  drinksCatalog,
  coffeeCatalog,
  teaCatalog,
  homemadeCatalog,
  fusionCatalog,
  signatureCatalog,
  beerCatalog,
  wineCatalog,
  wineCatalogExtra,
  spiritsCatalog,
  appetizerCatalog,
  appetizerCatalogExtra,
  appetizerCatalogMore,
  saladCatalog,
  saladCatalogExtra,
  noodleCatalog,
  specialtyCatalog,
  donburiCatalog,
  // mainCourseCatalog,
  mainCourseCatalogExtra,
  riceNoodleCatalog,
  friedNoodleCatalog,
  extrasCatalog,
  nigiriCatalog,
  makiCatalog,
  futoRollCatalog,
  sushiTapasCatalog,
} from "./food";

const getShuffledImages = () => {
  // Tạo mảng [1, 2, 3, ..., 18]
  const ids = Array.from({ length: 18 }, (_, i) => i + 1);

  // Thuật toán trộn Fisher-Yates để đảm bảo ngẫu nhiên hoàn toàn
  for (let i = ids.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [ids[i], ids[j]] = [ids[j], ids[i]];
  }

  // Chuyển mảng số thành mảng URL
  return ids.map((id) => ({
    id: id,
    alt: `img${id}`,
    url: `assets/imgs/foods/img-giri (${id}).jpg`,
    onClick: () => {},
  }));
};
const WrapComponentMenu = (props) => {
  const { handleClick, handleOpenLink, isHome = false } = props;
  const imagePool = getShuffledImages();
  const navigate = useNavigate();
  const getImages = (count) => imagePool.splice(0, count);

  const mergeCatalogs = (...catalogs) => {
    if (!catalogs || catalogs.length === 0) return { catalogs: [] };

    const base = catalogs[0] || { catalogs: [] };

    return {
      ...base,
      catalogs: catalogs.flatMap((c) => c?.catalogs || []),
    };
  };
  const groupedMenu = {
    // 🔥 MAIN FOOD (ưu tiên hiển thị đầu)
    main: [
      // mainCourseCatalog,
      extrasCatalog,
      ...(mainCourseCatalogExtra
        ? [mergeCatalogs(mainCourseCatalogExtra)]
        : []),
      donburiCatalog,
      riceNoodleCatalog,
      friedNoodleCatalog,
    ],

    // 🍣 SUSHI
    sushi: [nigiriCatalog, makiCatalog, futoRollCatalog, sushiTapasCatalog],

    // 🥗 STARTERS
    starters: [
      mergeCatalogs(
        appetizerCatalog,
        appetizerCatalogExtra,
        appetizerCatalogMore,
      ),
      mergeCatalogs(saladCatalog, saladCatalogExtra),
    ],

    // 🍜 VIETNAMESE / SOUP
    traditional: [noodleCatalog, specialtyCatalog],

    // 🍹 DRINKS
    drinks: [
      drinksCatalog,
      coffeeCatalog,
      teaCatalog,
      homemadeCatalog,
      fusionCatalog,
      signatureCatalog,
      beerCatalog,
      mergeCatalogs(wineCatalog, wineCatalogExtra),
      spiritsCatalog,
    ],

    // ➕ EXTRAS
    extras: [extrasCatalog],
  };
  const renderMenus = isHome
    ? groupedMenu.main.slice(0, 3)
    : [
        ...groupedMenu.main,
        ...groupedMenu.sushi,
        ...groupedMenu.starters,
        ...groupedMenu.traditional,
        ...groupedMenu.drinks,
        ...groupedMenu.extras,
      ];

  return (
    <>
      <div className={`${styles.containerPDF} `}>
        <a
          href="assets/menu/full.pdf" // hoặc "/full/full.pdf" tùy vị trí file
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.btnMore} ${styles.waves}`}
        >
          <div className={styles.iconBtnMore}>
            <PiFilePdfDuotone />
          </div>
          Menu-PDF
        </a>
      </div>
      {renderMenus.map((item, index) => {
        const position = index % 2 === 0 ? "right" : "left";
        return (
          <MenuComponents
            key={index}
            linkMenu="/speisekarte"
            handleClick={handleClick}
            handleOpenLink={handleOpenLink}
            images={getImages(2)}
            title={item.title}
            menuText="ONLINE BESTELLEN"
            foods={item.catalogs?.flatMap((c) => c.items) || item.foods || []}
            position={position}
            showAction={isHome}
            pdfLink="/assets/menu.pdf"
          />
        );
      })}
      {isHome && (
        <div className={styles.containerMore}>
          <button
            onClick={() => {
              navigate("/speisekarte");
            }}
            className={`${styles.btnMore} ${styles.waves}`}
          >
            vollständiges Menü
          </button>
        </div>
      )}
    </>
  );
};

export default WrapComponentMenu;
